import { convertDatesToISO, getHeaders } from '@/config/aux'
import { SerialSettings } from '../models/serialSettings'
import { SerialSettingsStateType } from './state'
import axios from 'axios'

export interface SerialSettingsActionsType {
  getSerialSettings(): Promise<void>
  getSerialSettingsByPort(port: string): Promise<void>
  postSerialSettings(serialSettings: SerialSettings): Promise<void>
  putSerialSettings(serialSettings: SerialSettings): Promise<void>
  deleteSerialSettings(id: string): Promise<void>
}

export const SerialSettingsActions = {
  async getSerialSettings(this: SerialSettingsStateType) {
    try {
      this.serialSettings = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/serial-settings`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((serialSetting: SerialSettings) => {
            this.serialSettings.push(serialSetting)
          })
        }
      })
    } catch (error) {
      console.error('Error getting SerialSettings', error)
    }
  },
  async getSerialSettingsByPort(this: SerialSettingsStateType, port: string) {
    try {
      this.serialSetting = null
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/serial-settings/port/${port}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          this.serialSetting = response.data
        }
      })
    } catch (error) {
      console.error('Error getting SerialSettings by port', error)
    }
  },
  async postSerialSettings(this: SerialSettingsStateType, serialSettings: SerialSettings) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/serial-settings`
      const data = convertDatesToISO(serialSettings.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.serialSettings.push(serialSettings)
        }
      })
    } catch (error) {
      console.error('Error posting SerialSettings', error)
    }
  },
  async putSerialSettings(this: SerialSettingsStateType, serialSettings: SerialSettings) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/serial-settings`
      const data = convertDatesToISO(serialSettings.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.serialSettings = this.serialSettings.map(s => (s.id === serialSettings.id ? serialSettings : s))
          }
        })
    } catch (error) {
      console.error('Error updating SerialSettings', error)
    }
  },
  async deleteSerialSettings(this: SerialSettingsStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/serial-settings/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.serialSettings = this.serialSettings.filter(s => s.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting SerialSettings', error)
    }
  },
}
